module.exports = __webpack_public_path__ + "app/assets/images/headerbackground.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/headerbackground.png
// module id = 1118
// module chunks = 7